var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('m-select',_vm._g(_vm._b({attrs:{"items":_vm.genders,"i18n-path":"profile.gender.items","sentry-tag":"language"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'m-select',{ ..._vm.$props, ..._vm.$attrs },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }